/* This file is autogenerated, see readme.md for instructions */
import LoomiSvgIcon from '@bloomreach/banana-theme/icons/loomi.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const LoomiIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <LoomiSvgIcon />
    </Icon>
  );
});

LoomiIcon.displayName = 'LoomiIcon';

export default LoomiIcon;
